










































import { Component, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter/ModalFooter.vue'

@Component({
  components: {
    ModalFooter
  }
})
export default class ModalBibliographyRegistrationSelection extends ComponentVue {
  dialog = false

  open(): void {
    this.dialog = true
  }

  close(): void {
    this.dialog = false
  }

  @Emit('book')
  onClickBook(): void {
    this.close()
  }

  @Emit('av')
  onClickUAv(): void {
    this.close()
  }

  @Emit('magazine')
  onClickMagazine(): void {
    this.close()
  }
}
